export const prodUrl =
  'https://analytics.carvana.io/edge/web-eventable/api/graph';
export const devUrl =
  'https://analytics.zagforward.com/edge/web-eventable/api/graph';
export const testUrl =
  'https://analytics.carvanatech.com/edge/web-eventable/api/graph';
